import { SubmissionError } from 'redux-form/immutable.js';
import { addAwsDomain } from './index.js';
import defaultImage from '../images/default.png';


/*
 * Transforms API violations array to redux-form errors object
 */

export const toSubmissionError = (error) => {
    if (!error.response) {
        return new SubmissionError({ _error: error.message });
    }

    const { data } = error.response;

    if (typeof data === 'string') {
        return new SubmissionError({ _error: data });

    } else if (typeof data === 'object' && typeof data.details === 'object' && data.details.violations) {
        const {
            details: {
                violations,
            },
            error: _error,
        } = data;

        const fieldErrors = violations.reduce((prev, { field, message }) => ({
            ...prev,
            [field.toLowerCase()]: message,
        }), {});

        return new SubmissionError({ _error, ...fieldErrors });
    } else if (typeof data === 'object' && typeof data === 'object' && data.error) {
        return new SubmissionError({ _error: data.error });
    }

    return new SubmissionError({ _error: error.message });
};

export const toSubmissionErrorSytemPortal = (error) => {
    if (!error.response) {
        return new SubmissionError({ _error: error.message });
    }

    const { data } = error.response;

    if (typeof data === 'string') {
        return new SubmissionError({ _error: data });

    } else if (typeof data === 'object' && typeof data.details === 'object' && data.details.violations) {
        const {
            details: {
                violations,
            },
            error: _error,
        } = data;

        const fieldErrors = violations.map(err => `\n\n${err.field}, ${err.message}`).toString();

        return new SubmissionError({ _error: `${_error} ${fieldErrors}` });
    }

    return new SubmissionError({ _error: error.message });
};

/*
 * Vertex data
 */
export const toVertexLogoURL = ({ logo_id, logo_url }) => (
    logo_id ? addAwsDomain(logo_url) : defaultImage
);
